import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin, ArrowUpRight, Youtube, Linkedin } from 'lucide-react';
import { BRAND, NAV_LINKS } from '../../data/mock';
import logoImg from '../../assets/logos/inkfly_logo.png';

const LOGO_URL = logoImg;

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      {/* Main Footer */}
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="Inkfly Photo Booth"
                className="h-12 w-auto"
              />
              <div>
                <span className="font-bold text-xl text-gray-900 block leading-tight">
                  Photo Booth
                </span>
                <span className="text-[9px] text-[#00BFFF] uppercase tracking-[0.15em] font-medium">
                  Capture. Create. Celebrate.
                </span>
              </div>
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              India&apos;s pioneer photo booth company since 2012. Creating iconic photo experiences for events, brands & celebrations.
            </p>
            <div className="flex items-center gap-3">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#00BFFF]/10 flex items-center justify-center text-[#00BFFF] hover:bg-[#00BFFF] hover:text-white transition-all"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={BRAND.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#00BFFF]/10 flex items-center justify-center text-[#00BFFF] hover:bg-[#00BFFF] hover:text-white transition-all"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a
                href={BRAND.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#00BFFF]/10 flex items-center justify-center text-[#00BFFF] hover:bg-[#00BFFF] hover:text-white transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-semibold text-gray-900 mb-6 uppercase tracking-wider text-sm">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="footer-link hover:text-[#00BFFF]">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-display font-semibold text-gray-900 mb-6 uppercase tracking-wider text-sm">
              Products
            </h4>
            <ul className="space-y-3">
              <li><Link to="/products" className="footer-link">iMIRROR</Link></li>
              <li><Link to="/products" className="footer-link">AirBooth</Link></li>
              <li><Link to="/products" className="footer-link">Retro Booth</Link></li>
              <li><Link to="/products" className="footer-link">Time Freeze Booth</Link></li>
              <li><Link to="/products" className="footer-link">Photo Mosaic Wall</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-semibold text-gray-900 mb-6 uppercase tracking-wider text-sm">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#00BFFF] mt-1 flex-shrink-0" />
                <div>
                  <a href={`tel:${BRAND.phone}`} className="footer-link block">
                    {BRAND.phone}
                  </a>
                  <a href={`tel:${BRAND.phone2}`} className="footer-link block">
                    {BRAND.phone2}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#00BFFF] mt-1 flex-shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="footer-link">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#00BFFF] mt-1 flex-shrink-0" />
                <span className="footer-link">{BRAND.address}</span>
              </li>
            </ul>
            <a
              href={BRAND.photoboothGuruUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-[#00BFFF] hover:text-[#0099CC] transition-colors group"
            >
              <span className="text-sm font-medium">Own a Photo Booth</span>
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200">
        <div className="container-custom py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Inkfly Photo Booth. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Chennai&apos;s First Photo Booth Company Since 2012
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
